import { useCallback } from 'react';
import { useLocation } from 'react-router-dom';

import { PAGE_PARAM } from '@/constants/ObjectivePeriodLens';
import { setOrDelete, useReplaceSearch } from '@/hooks/utils/useReplaceSearch';

/**
 * The page of a server-paged list, kept in the address beside its filters so that stepping back to
 * the list finds it where it was left. The first page is the address without one.
 */
export const useAddressedPageNumber = () => {
    const { search } = useLocation();
    const replaceSearch = useReplaceSearch();

    const pageNumber = Number(new URLSearchParams(search).get(PAGE_PARAM)) || 1;
    const setPageNumber = useCallback(
        (page: number) =>
            replaceSearch((params) =>
                setOrDelete(params, PAGE_PARAM, page > 1 ? String(page) : ''),
            ),
        [replaceSearch],
    );

    return { pageNumber, setPageNumber };
};
